module.exports = __webpack_public_path__ + "img/IL-baretto.54c40025.jpg";